export const isObject = <T>(value: T) => typeof value === 'object' && !!value;
